/**
 * Created by mh on 2017/4/5.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

import SignupForm from './forms/definitions/SignupForm';
import FormSignup from './forms/FormSignup';

const sonosLogo = require('./sonos.svg');

@observer
export default class SignUp extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="row">
                <div className="col-12 signin">

                    <h4>SONOS deliver.media services</h4>
                    <p>
                        Sign up now to integrate your <b>deliver.media</b> environment with the SONOS ecosystem.<br />
                        Contact us for detailed pricing information or for a short introduction into our SONOS
                        integration.
                    </p>

                    <img
                        src={sonosLogo}
                        className="vendor-logo img-fluid mx-auto d-block"
                        alt="SONOS Logo" />

                    <FormSignup className="form-signin" form={SignupForm} />

                </div>
            </div>
        );
    }
}
